import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REALESTATE_INVESTMENT } from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import mixpanel from "mixpanel-browser";

export const submitRealEstateInvestment = createAsyncThunk(
  "investment/Submit",
  async ({ data, failed, cb }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_REALESTATE_INVESTMENT,
        data: data,
      });
      toast.success("Investment added successfully");

      mixpanel.track("WEB-Invested", {
        type: "Invest",
      });

      cb(response?.data);

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();
      mixpanel.track("WEB-Invest Failed", {
        type: "Invest",

        message: msg,
      });
      return rejectWithValue(
        error.response?.data || "An unexpected error occurred"
      );
    }
  }
);
